import { j as m } from "../../_virtual/jsx-runtime.js";
import { c } from "../../_virtual/compiler-runtime.js";
import { cn as a } from "../../utils/cn.js";
const n = (i) => {
  const e = c.c(9);
  let l, o;
  e[0] !== i ? ({
    className: l,
    ...o
  } = i, e[0] = i, e[1] = l, e[2] = o) : (l = e[1], o = e[2]);
  let r;
  e[3] !== l ? (r = a("inline-block", l), e[3] = l, e[4] = r) : r = e[4];
  let s;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m.jsx("path", { d: "M6.79491 5.81935C7.18432 5.39355 7.81568 5.39355 8.20509 5.81935L11.2942 9.19709C11.7339 9.6779 11.4225 10.5 10.8006 10.5H4.1994C3.57755 10.5 3.26612 9.67789 3.70584 9.19709L6.79491 5.81935Z" }), e[5] = s) : s = e[5];
  let t;
  return e[6] !== o || e[7] !== r ? (t = /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "16", height: "16", fill: "currentColor", role: "img", focusable: "false", className: r, ...o, children: s }), e[6] = o, e[7] = r, e[8] = t) : t = e[8], t;
};
n.displayName = "SmallUpArrowIcon";
export {
  n as SmallUpArrowIcon
};
